import styled from 'styled-components'

export const ContainerButton = styled.button`
width: 182.81px;
height: 36.13px;
background: #9758A6;
border-radius: 20px;
border: none;
cursor: pointer;
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 24px;
text-align: center;
color: #EEEEEE;

&:hover{
  opacity: 0.8;
}

&:active{
  opacity: 0.6;
}
`
